"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconAlertTriangleFill', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M15.86,14.51A1,1,0,0,1,15,15H1a1,1,0,0,1-.88-1.47l7-13a1,1,0,0,1,1.76,0l7,13A1,1,0,0,1,15.86,14.51ZM9,8.48v-4a1,1,0,0,0-2,0v4a1,1,0,0,0,2,0Zm-.29,4.67a1,1,0,0,0,.21-.33.94.94,0,0,0,0-.76,1,1,0,0,0-.21-.32,1,1,0,0,0-1.42,0,1,1,0,0,0-.21,1.08,1,1,0,0,0,.21.33,1.19,1.19,0,0,0,.33.22,1,1,0,0,0,1.09-.22Z'],
  params: {
    viewBox: '0 0 16 16'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M19.78,17.89,10.78,1A.92.92,0,0,0,9.22,1l-9,16.87a.89.89,0,0,0,0,.88A.88.88,0,0,0,1,19.2H19a.88.88,0,0,0,.76-.43A.89.89,0,0,0,19.78,17.89ZM10.71,17a1.19,1.19,0,0,1-.33.22A1,1,0,0,1,9.29,15.6a1,1,0,0,1,1.09-.22.83.83,0,0,1,.33.22,1,1,0,0,1,0,1.41ZM11,12.16a1,1,0,0,1-2,0V7a1,1,0,0,1,2,0Z'],
  params: {
    viewBox: '0 0 20 20'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M 23.167969 21.40625 L 12.667969 1.15625 C 12.539062 0.90625 12.28125 0.746094 12 0.746094 C 11.71875 0.746094 11.460938 0.90625 11.332031 1.15625 L 0.832031 21.40625 C 0.710938 21.636719 0.722656 21.917969 0.859375 22.140625 C 0.996094 22.363281 1.238281 22.5 1.5 22.5 L 22.5 22.5 C 22.761719 22.5 23.003906 22.363281 23.140625 22.140625 C 23.277344 21.917969 23.289062 21.636719 23.167969 21.40625 Z M 12.539062 20.039062 C 12.46875 20.109375 12.382812 20.164062 12.292969 20.203125 C 12.199219 20.242188 12.101562 20.257812 12 20.25 C 11.585938 20.25 11.25 19.914062 11.25 19.5 C 11.25 19.398438 11.273438 19.300781 11.308594 19.207031 C 11.347656 19.117188 11.402344 19.03125 11.46875 18.960938 C 11.539062 18.886719 11.625 18.832031 11.722656 18.796875 C 11.859375 18.738281 12.007812 18.722656 12.148438 18.75 C 12.199219 18.757812 12.246094 18.773438 12.292969 18.796875 C 12.339844 18.808594 12.382812 18.835938 12.421875 18.871094 L 12.539062 18.960938 C 12.609375 19.03125 12.667969 19.113281 12.703125 19.207031 C 12.738281 19.300781 12.753906 19.402344 12.75 19.5 C 12.753906 19.699219 12.679688 19.894531 12.539062 20.039062 Z M 12.75 15 C 12.75 15.414062 12.414062 15.75 12 15.75 C 11.585938 15.75 11.25 15.414062 11.25 15 L 11.25 7.5 C 11.25 7.085938 11.585938 6.75 12 6.75 C 12.414062 6.75 12.75 7.085938 12.75 7.5 Z M 12.75 15'],
  params: {
    width: '32',
    height: '32',
    viewBox: '0 0 24 24'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M30.89,28.54l-14-27a1,1,0,0,0-1.78,0l-14,27A1,1,0,0,0,2,30H30a1,1,0,0,0,.89-1.46ZM16.72,26.72a1.19,1.19,0,0,1-.33.22A.88.88,0,0,1,16,27a1,1,0,0,1-1-1,1.09,1.09,0,0,1,.08-.39,1.15,1.15,0,0,1,.21-.33.91.91,0,0,1,.34-.22A1,1,0,0,1,16.2,25a.6.6,0,0,1,.19.06.42.42,0,0,1,.17.1l.16.12a1,1,0,0,1,.22.33A1.09,1.09,0,0,1,17,26,1,1,0,0,1,16.72,26.72ZM17,20a1,1,0,1,1-2,0V10a1,1,0,1,1,2,0Z'],
  params: {
    viewBox: '0 0 32 32'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;